import React from 'react'

import { Container, Icon, Info } from './styled'

type Props = {
  color: string
  title: string
  subtitle: string
  background: string
  border: string
  icon: React.ReactNode | string
}

export const Card = ({
  color,
  icon,
  subtitle,
  title,
  background,
  border,
}: Props) => {
  return (
    <>
      <Container border={border} background={background}>
        <Icon>{icon}</Icon>
        <Info color={color}>
          <h2>{title}</h2>
          <span>{subtitle}</span>
        </Info>
      </Container>
    </>
  )
}
